import DatePicker from '@mui/lab/DatePicker';
import { TextField } from '@mui/material';
import { Control, FieldError, FieldValues, Path, RegisterOptions, useController } from 'react-hook-form';

type FormDatepickerFieldProps<T extends FieldValues> = {
    name: Path<T>;
    label?: string;
    rules?: Omit<RegisterOptions<T>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>;
    fieldError?: FieldError;
    control: Control<T>;
    disabled?: boolean;
};

export function FormDatepickerField<T extends FieldValues>({ name, label, rules, fieldError, control, disabled = false}: FormDatepickerFieldProps<T>) {
    const {
        field: { onChange, value, ref },
    } = useController({
        name,
        rules,
        control,
    });

    return (
        <DatePicker
            clearable
            label={label + (!!rules?.required ? ' *' : '')}
            value={value}
            onChange={onChange}
            renderInput={(params) => (
                <TextField
                    fullWidth
                    id={name}
                    {...params}
                    error={!!fieldError}
                    helperText={fieldError?.message}
                    inputRef={(inputRef) => {
                        if (params.inputRef && typeof params.inputRef === 'function') {
                            params.inputRef(inputRef);
                        }
                        ref(inputRef);
                    }}
                />
            )}
            mask='__/__/__'
            inputFormat='MM/dd/yy'
            disabled={disabled}
        />
    );
}
